import { Translation } from "@bimproject/t9n";

import Address from "./Address";

export default class Brand {

    about: Translation[];

    address: Address;

    alternativeNames: string[];

    arbitraryData: Record<string, unknown>;

    color: string;

    coverImage: string;

    enableCatalog: boolean;

    features: string[];

    id: string;

    legacyAlias: string;

    legacyID: string;

    logo: string;

    name: string;

    primaryLanguage: string;

    url: string;

    constructor(brand: BrandStruct) {
        Object.assign(this, brand);
        Object.freeze(this);
    }

    change(change: BrandStruct) {
        return new (this.constructor as new (brand: BrandStruct) => this)({ ...this, ...change });
    }

}

type Attributes<T> = {
    [K in keyof T]: T[K] extends (...args: never[]) => unknown ? never : K
}[keyof T];

type BrandAttributes = Attributes<Brand>;
type BrandStruct = Partial<Pick<Brand, BrandAttributes>>;
